import './CountrySelect_.scss';

export const CountrySelectTheme = {
    Inline: 'component_country_select__inline_theme',
};
